module.exports = __webpack_public_path__ + "static/img/popup.e5365f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/popup.png
// module id = rewo
// module chunks = 0